import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BusinessFieldViewType} from '../../model/BusinessFieldViewType';
import {BusinessFieldRef} from '../../model/BusinessFieldRef';
import {BoInstanceSelectorRecord} from '../../model/BoInstanceSelectorRecord';
import {BoInstanceSelectorConfig} from './BoInstanceSelectorConfig';
import {BoInstanceToSave} from '../../model/BoInstanceToSave';
import {BoInstanceAmountToSave} from '../../model/BoInstanceAmountToSave';
import {BoiDialogData} from '../../model/BoiDialogData';

@Component({
  selector: 'app-bo-instance-selector',
  templateUrl: './bo-instance-selector.component.html',
  styleUrls: ['./bo-instance-selector.component.scss']
})
export class BoInstanceSelectorComponent {

  @Input() businessFields: BusinessFieldRef[];
  @Input() businessObjectId: string;
  @Input() chosenIds: string[];

  @Input() config: BoInstanceSelectorConfig;

  @Output() boInstanceCreated = new EventEmitter<BoInstanceToSave>();
  @Output() boiAmountChanged = new EventEmitter<BoInstanceAmountToSave>();
  @Output() boInstanceAdded = new EventEmitter<BoInstanceSelectorRecord>();
  @Output() boInstanceDeleted = new EventEmitter<BoInstanceSelectorRecord>();
  @Output() boiDialogOpenEvent = new EventEmitter<BoiDialogData>();
  @Output() businessFieldToShowChanged = new EventEmitter<BusinessFieldRef>();
  @Output() allBoInstanceDeleted = new EventEmitter<void>();
  @Output() costCalcEnabledChanged = new EventEmitter<boolean>();
  @Output() costCalcFieldIdChanged = new EventEmitter<string>();
  @Output() costCalcPriceLabelChanged = new EventEmitter<string>();
  ViewType = BusinessFieldViewType;

  onCostCalcEnabledChanged(value: boolean) {
    this.costCalcEnabledChanged.emit(value);
  }

  onCostCalcFieldIdChanged(id: string) {
    this.costCalcFieldIdChanged.emit(id);
  }

  onCostCalcPriceLabelChanged(value: string) {
    this.costCalcPriceLabelChanged.emit(value);
  }

}
